import { useState, useEffect } from "react";
import { getViewport, isPhoneViewport } from "../utils/viewport";

export default function useIsPhone() {
  // 构建期预渲染时 window 由 dom-shim 伪造，用 __SSR_VIEWPORT__ 区分真实浏览器环境
  const isClient = typeof window !== "undefined" && !globalThis.__SSR_VIEWPORT__;

  const [viewport, setViewport] = useState(getViewport);

  useEffect(() => {
    if (!isClient) {
      return undefined;
    }

    function handleResize() {
      setViewport(getViewport());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return isPhoneViewport(viewport.width, viewport.height);
}
